import React, { isValidElement } from "react";
import { FormattedMessage } from "react-intl";
function isFormattedMessageProps(value) {
    return value != null && typeof value === "object" && !isValidElement(value);
}
const Message = ({ value }) => {
    if (isFormattedMessageProps(value)) {
        return (<FormattedMessage {...value}/>);
    }
    return value;
};
export default Message;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/common/Message/Message.tsx